import type { JSX } from "react";
import { type ImageTypesEnum } from "../types/directionsTypes";
import WalkingIcon from "@/pages/home/assets/step_icons/walking.svg?react";
import StairsUpIcon from "@/pages/home/assets/step_icons/stairs_up.svg?react";
import StairsDownIcon from "@/pages/home/assets/step_icons/stairs_down.svg?react";
import {
  Book,
  FlaskConical,
  GraduationCap,
  LaptopMinimal,
  Presentation,
} from "lucide-react";

export const IMAGES: Record<ImageTypesEnum, JSX.Element> = {
  walk: <WalkingIcon className="w-6 h-6 text-gray-600" />,
  stairs_up: <StairsUpIcon className="w-6 h-6 text-gray-600" />,
  stairs_down: <StairsDownIcon className="w-6 h-6 text-gray-600" />,
  entry: <GraduationCap className="w-6 h-6 text-gray-600" />,
  computer_room: <LaptopMinimal className="w-6 h-6 text-gray-600" />,
  lab_room: <FlaskConical className="w-6 h-6 text-gray-600" />,
  lecture_room: <Presentation className="w-6 h-6 text-gray-600" />,
  wardrobe: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden
      className="w-6 h-6 text-gray-600"
    >
      <rect
        x="5"
        y="4"
        width="14"
        height="16"
        rx="1"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M12 8v4"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  ),
  library: <Book className="w-6 h-6 text-gray-600" />,
};
